import Spinner from "../../../Spinner";

export default function RedoEntryButton({entry, loading, locked, lockReason}) {
	const modalId = `reviewModal-${entry.id}`;

	// See DeleteEntryButton: the title lives on the wrapper because a disabled button has no
	// hover of its own.
	return (
		<span title={locked ? lockReason : undefined}>
			<button className={"btn btn-sm btn-warning"} type={"button"} data-bs-toggle={locked ? undefined : "modal"} data-bs-target={locked ? undefined : `#${modalId}`} disabled={loading || locked}>{loading && <Spinner small={true} />}Edit</button>
		</span>
	);
}
